import { useRef } from "react";

interface UploadDropzoneProps {
  onFiles: (files: File[]) => void;
}

export default function UploadDropzone({ onFiles }: UploadDropzoneProps) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const openPicker = () => inputRef.current?.click();

  const handleFiles = (files: FileList | null) => {
    if (!files) return;
    onFiles(Array.from(files));
  };

  return (
    <div>
      <div
        className="w-full rounded-[10px] border-2 border-dashed flex items-center justify-center py-16 text-center text-gray-600 cursor-pointer"
        style={{ borderColor: "#D1E2DD" }}
        onClick={openPicker}
      >
        <div>
          <div className="text-3xl mb-2" style={{ color: "#9aa7a2" }}>
            ↓
          </div>
          <div>Importer un fichier (5 MB maximum)</div>
        </div>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept=".pdf,image/*"
        multiple
        className="hidden"
        onChange={(event) => handleFiles(event.target.files)}
      />
    </div>
  );
}

